var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.6923C20 13.3043 19.7659 13.8913 19.3491 14.3241C18.9324 14.7569 18.3671 15 17.7778 15H2.22222C1.63285 15 1.06762 14.7569 0.650874 14.3241C0.234126 13.8913 0 13.3043 0 12.6923V10.3846H20V12.6923Z",
    fill: "#CE2028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.61552H20V10.3848H0V4.61552Z",
    fill: "#22408C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0H2.22222C1.63285 0 1.06762 0.243131 0.650874 0.675907C0.234126 1.10868 0 1.69565 0 2.30769L0 4.61538H20V2.30769C20 1.69565 19.7659 1.10868 19.3491 0.675907C18.9324 0.243131 18.3671 0 17.7778 0Z",
    fill: "#EEEEEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuFlag);
export default __webpack_public_path__ + "static/media/ru-flag.7189de5e6d28fffc1a025daa847edc33.svg";
export { ForwardRef as ReactComponent };